'use client'

import { MouseEvent } from 'react'

interface StatusProps {
  children?: React.ReactNode
  text: string | React.ReactNode
  background?: string
  ghost?: boolean
  className?: string
  color?: string
  attributes?: any
  onClick?: (e: MouseEvent) => void
  size?: 'default' | 'large' | 'small'
  statusColor?: 'completed' | 'pending' | 'canceled' | 'delivered' | 'return' | 'transit' | string
}

export const Status = ({
  children,
  text,
  className,
  background,
  color,
  attributes,
  size = 'default',
  statusColor,
}: StatusProps) => {
  const getColor = () => {
    switch (statusColor?.toLowerCase()) {
      case 'canceled':
        return { color: '#EF4444', background: '#FEF2F2' }
      case 'completed':
        return { color: '#059669', background: '#ECFDF5' }
      case 'pending':
        return { color: '#FF5C00', background: '#FFF1BE' }
      case 'delivered':
        return { color: '#C6A538', background: '#FEFAED' }
      case 'return':
        return { color: '#334155', background: '#F8FAFC' }
      case 'transit':
        return { color: '#1D4ED8', background: '#E8EDFB' }
      default:
        return { color, background }
    }
  }
  const colorOfStatus = getColor()
  return (
    <button
      disabled={attributes && attributes?.disabled}
      onClick={(e) => !attributes?.disabled && attributes?.onClick?.(e)}
      className={`border border-primary ${size == 'default' ? 'w-[120px] rounded-2xl px-2 py-[0.375rem]' : size == 'large' ? 'min-w-[100px] rounded-full px-2 py-2' : ''} text-center text-sm ${className}`}
      style={{
        color: colorOfStatus?.color,
        backgroundColor: colorOfStatus?.background,
        border: `${colorOfStatus?.background && `1px solid ${colorOfStatus?.background}`}`,
      }}
    >
      {text || children}
    </button>
  )
}
